// import { CaretLeft } from 'phosphor-react'
import React from 'react'
// import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

const HeaderBox = styled.p`
  color: #2a2a2a;
  font-size: 22px;
  font-weight: bold;
  text-transform: capitalize;
  margin-bottom: 0;
  padding-right: 10px;
  position: relative;
  display: inline-block;
  margin-left: 10px;

  &::after {
    border-radius: 10px;
    content: '';
    display: block;
    width: 20px;
    height: 2px;
    // background-color: #5c67ca;
    background: linear-gradient(90deg, #5a65c9 20%, #303b97 100%);

    position: absolute;
    top: 15%;
    left: 0%;
    transform: translateY(-50%);
  }
`

export const ScreenHeader = ({ text }) => {
  // const navigate = useNavigate()
  return (
    <HeaderBox className="d-flex flex-row  py-2 align-items-center">
      {/* <CaretLeft
        onClick={() => navigate(-1)}
        size={22}
        color="#2454FF"
        className="me-3 cursor-pointer"
      />{' '} */}
      {text}
    </HeaderBox>
  )
}
